const priceOverrideResetAllClickHandlerUtil = ({
    setPricingNotes,
    setPriceOverrideReason,
    setPriceOverrideTableData,
    priceOverrideTableData,
    setFooterButtonStatuses,
    footerButtonStatuses,
    cancel,
}) => {
    const inputElements = document.getElementsByClassName('adjustedPriceInput');
    for (const element of inputElements) element.value = '';
    setPricingNotes('');
    setPriceOverrideReason('');
    setPriceOverrideTableData(
        priceOverrideTableData.map((item) => ({
            ...item,
            adjustedOtherQtyPrice: null,
            adjustedUsedQtyPrice: null,
            adjustedExtPrice: null,
            invalidOtherQtyAdjBasePriceMsg: null,
            invalidUsedQtyAdjBasePriceMsg: null,
        }))
    );
    setFooterButtonStatuses(
        footerButtonStatuses.map((x) =>
            x.btnName !== cancel && x.btnVisibility
                ? { ...x, isBtnDisable: false }
                : x
        )
    );
};

export default priceOverrideResetAllClickHandlerUtil;